import { BannerAppSmart as Banner } from '@components/Layout/Header/Banners';
import { formatPrismicData } from '@monofront/business/utils';
import { RichText } from 'prismic-reactjs';
import ResponsiveImage from '@monofront/design-system/components/ResponsiveImage';
import React from 'react';
import { IBannerAppSmart } from '@monofront/types';

interface IBannerAppSmartProps {
  prismicContent: IBannerAppSmart;
}

const BannerAppSmart: React.FC<IBannerAppSmartProps> = ({ prismicContent }) => {
  // FIXME: fixed in !1994
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const { buttonText, title, text, bannerIcon, backgroundColor } =
    // FIXME: fixed in !1994
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    formatPrismicData(prismicContent.primary);

  return (
    <Banner
      backgroundColor={backgroundColor}
      buttonText={buttonText}
      icon={
        bannerIcon && (
          <ResponsiveImage
            src={bannerIcon.url}
            alt={bannerIcon.alt}
            width={bannerIcon?.dimensions?.width}
            height={bannerIcon?.dimensions?.height}
          />
        )
      }
      title={<RichText render={title} />}
      text={<RichText render={text} />}
    />
  );
};

export default BannerAppSmart;
